// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__o-BB9","title":"Info_title__3uT33","links":"Info_links__3vvNQ","link":"Info_link__3V7Wh","logo":"Info_logo__3iGMY"};